import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-ink px-5 text-cream">
      <div
        data-testid="cpmc-payment-cancel-page"
        className="w-full max-w-lg rounded-3xl border border-cream/10 bg-cream/[0.05] p-10 text-center backdrop-blur"
      >
        <XCircle className="mx-auto mb-6 h-16 w-16 text-coral" />
        <h1 className="font-display text-3xl font-bold">Paiement annulé</h1>
        <p className="mt-4 text-sm leading-relaxed text-cream/70 sm:text-base">
          Aucun montant n'a été débité. Votre inscription est conservée —
          vous pouvez reprendre le paiement quand vous le souhaitez.
        </p>
        <a
          href="/#inscription"
          data-testid="cpmc-payment-cancel-back"
          className="mt-8 inline-block rounded-full bg-sun px-6 py-3 font-semibold text-ink transition-colors duration-300 hover:bg-teal hover:text-cream"
        >
          Retour à l'inscription
        </a>
      </div>
    </div>
  );
}
